// 全局混入所有組件中
import global from '@/assets/js/global'
import functions from '@/assets/js/functions'
import { mapState, mapGetters } from 'vuex'

const common = {
  data () {
    return {
      ...global,
    }
  },
  methods: {
    ...functions,
    // 開關 Debug 模式
    toggleDebugMode (_) {
      this.$store.commit('setDebugMode', _)
    },
    // 至最新表單列表
    toLatestForm (query = null, level = null) {
      const formInfo = this.$store.state.formInfo
      if (!formInfo) return

      const period = Math.max(...Object.keys(formInfo))
      const periodInfo = formInfo[Math.max(...Object.keys(formInfo))]
      if (!periodInfo) return

      level = level || Math.max(...Object.keys(periodInfo))

      this.$router.push({
        name: 'form',
        params: { period, level },
        query,
      })
    },
  },
  computed: {
    groupTableList () {
      const list = []
      for (const key in this.groupTable) { list.push({ id: parseInt(key), name: this.groupTable[key] }) }
      return list
    },
    isMobileForm () {
      return this.$vuetify.breakpoint.smAndDown && ['form'].some(name => this.$route.name === name)
    },
    // 當前頁面名稱
    currentPageName () {
      const _ = this.$route
      return _ && _.meta && _.meta.title
        ? _.meta.title
        : ''
    },
    isMobile () {
      return this.$vuetify.breakpoint.smAndDown
    },
    // 映射 vuex 的 state
    ...mapState({
      userId: 'userId',
      token: 'token',
      statePreference: 'preference',
    }),
    // 映射 vuex 的 getters
    ...mapGetters([
      'isECPay',
      'isDebugMode',
      'isDarkTheme',
    ]),
  },
}

export { common }
